export default ({React,connect,CollapsePanel,FileActions,StylePicker,slate,FileModal,Icon})->

  { Block, Text } = slate

  class ResourceToolbar extends React.Component

    constructor:(props)->
      super(props)
      @state = {
        src:null,
        choosing:false
        inputheight:null
        style:null
      }

    componentDidMount:->
      @stateFromTag()

    componentDidUpdate:(prev_props,prev_state)->
      @stateFromTag() if prev_props.value.change().value.startBlock != @props.value.change().value.startBlock 

    stateFromTag:->
      tag = @getTag()
      return if !tag
      attrs = tag.data.toObject()
      @setState({src:attrs.src}) if attrs.src 
      @setState({style:attrs.style}) if attrs.style

    getTag:->
      change = @props.value.change()
      tags = change.value.blocks.filter (node)-> node.type == "duoView3d"
      return tags.get(0) if tags.size > 0

    updateEditor:()->
      tag = @getTag()
      return if !tag
      change = @props.value.change()
      attrs = {}
      attrs.src = if @state.src? then @state.src else null
      attrs.style = if @state.style? then @state.style else null
      change.setNodeByKey(tag.key, {data: {...tag.data.toObject(),...attrs}}) 
      @props.setValue(change.value)

    fileSelected:(src)->
      @setState({choosing:false,src},=> @updateEditor())
      
    showFileModal:(e)->
      e?.preventDefault()
      @setState({choosing:true})  

    blurOnEnter:(event)=>
      if event.keyCode == 13
       event.target.blur()

  
    updateStyle:(key,val,number)=>
      newstyle = Object.assign({},@state.style)
      newstyle[key] = if number then Math.round(+val) else val
      delete newstyle.width if key == "width" && !val # if no width set - we make these auto
      console.log("newstyle",newstyle)
      @setState({style:newstyle})

    closeModal:=>
      @setState({choosing:false})

    render:->
      <CollapsePanel title="3d Viewer">
        <div className="imagetoolbar">
          <div className="formhoriz" >
            <label>Source</label>
            <div className="input-group">
              <input className="form-control" value={@state.src || ""} onChange={(e)=>@setState({src:e.target.value})} onBlur={(e)=> if e.target.value != @state.src then @fileSelected(@state.src)} />
              <button className="btn btn-default" onClick={(e)=> @showFileModal(e)}><Icon icon="folder" /></button>
            </div>

            <label>Height</label>
            <input className="form-control" onKeyDown={@blurOnEnter} value={parseInt(@state.style?.height,10) || 0} onChange={(e)=>@updateStyle("height",e.target.value,true)} onBlur={(e)=> @updateEditor()} />
          </div>
        </div>
        {if @state.choosing
          <FileModal title="Choose 3d Model" path={if @state.src then @state.src.replace(/[^\/]+$/,"") else "/downloads/3d-models/"} onSelect={(path)=> @fileSelected(path)} onClose={=> @closeModal()}/>
        }
      </CollapsePanel>

  connect(
    (state)->
      settings:state.settings
      toolbar_width:state.toolbar_width
      toolbars_active:state.toolbars_active
  )(ResourceToolbar)